export enum TipoIndicador {
  Valor = 'Valor' ,
  Texto = 'Texto',
  Data = 'Data',
  Lista = 'Lista'
}
